import BasePublicApiClient from '@/clients/BasePublicApiClient'
import { RECAPTCHA_SERVICE_NAME, WebToTextConstants } from '@/constants'

export default class WorkflowServiceClient extends BasePublicApiClient {
  constructor (args) {
    super(args)
    this.gServiceName = RECAPTCHA_SERVICE_NAME
  }

  saveMessageAsSMS (message, token = '') {
    let newPatient = null
    switch (message.patientType) {
      case WebToTextConstants.PATIENT_TYPE.NEW:
        newPatient = true
        break
      case WebToTextConstants.PATIENT_TYPE.RETURNING:
        newPatient = false
        break
      case WebToTextConstants.PATIENT_TYPE.OTHER:
        newPatient = null
        break
    }

    const data = {
      location_number: message.locationNumber,
      first_name: message.firstName,
      last_name: message.lastName,
      mobile_number: message.mobileNumber,
      email: message.email,
      message: message.message,
      new_patient: newPatient,
      practice_id: message.practiceUuid,
      location_id: message.locationUuid,
      origin: WebToTextConstants.ORIGIN_WEBTOTEXT
    }

    return this.client.post('/workflows/workflow/save_incoming_sms_v2', data, {
      headers: {
        'g-recaptcha-service': this.gServiceName,
        'g-recaptcha-token': token
      }
    })
  }
}
